export default __webpack_public_path__ + "5c7d7d6deb1d2ec8d48c4aba5aa30ee4.woff2";